import layout from '../views/layout/layout.vue'
let map = new Map()
map.set('clinic', () => import('../views/page/clinic/clinic.vue'))
map.set('pathology', () => import('../views/page/pathology/pathology.vue'))
map.set('psychosis', () => import('../views/page/psychosis/psychosis.vue'))
map.set('exhibit', () => import('../views/page/exhibit/exhibit.vue'))
map.set('poison', () => import('../views/page/poison/poison.vue'))
map.set('wirt', () => import('../views/page/wirt/wirt.vue'))
map.set('trace', () => import('../views/page/trace/trace.vue'))
map.set('physical', () => import('../views/page/physical/physical.vue'))
map.set('recording', () => import('../views/page/recording/recording.vue'))
map.set('picture', () => import('../views/page/picture/picture.vue'))
map.set('eletronic', () => import('../views/page/eletronic/eletronic.vue'))
map.set('contaminate', () => import('../views/page/contaminate/contaminate.vue'))
map.set('water', () => import('../views/page/water/water.vue'))
map.set('air', () => import('../views/page/air/air.vue'))
map.set('soil', () => import('../views/page/soil/soil.vue'))
map.set('sea', () => import('../views/page/sea/sea.vue'))
map.set('zoology', () => import('../views/page/zoology/zoology.vue'))
map.set('other', () => import('../views/page/other/other.vue'))
map.set('clinicForm', () => import('../views/page/clinic/clinicForm.vue'))
map.set('alteration', ()=> import('../views/page/clinic/alteration.vue'))
map.set('real', () => import('../views/page/real/real.vue'))
map.set('forget', () => import('../views/page/forget/forget.vue'))

function getRouterList(callback) {
	let leftnav = JSON.parse(localStorage.getItem('leftnav'))
	digui(leftnav)
	function digui(leftnav) {
		leftnav.forEach(function(item) {
			item.component = map.get(item.component) //通过映射找到我们定义好的组件
		})
	}
	const router = [{
		path: '/layout',
		name: 'layout',
		component: layout,
		redirect: leftnav[0].path,
		children: leftnav
	}, {
		path: '*',
		redirect: '/notFound'
	}]
	callback(router)
}

export default {
	getRouterList
}